import { render, staticRenderFns } from "./QueryCreated.vue?vue&type=template&id=4a6ceedd&scoped=true&"
import script from "./QueryCreated.vue?vue&type=script&lang=js&"
export * from "./QueryCreated.vue?vue&type=script&lang=js&"
import style0 from "./QueryCreated.vue?vue&type=style&index=0&id=4a6ceedd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6ceedd",
  null
  
)

export default component.exports